<template>
  <div class="affordability-preview">
    <div class="affordability-preview__bar">
      <div
        v-if="greenWidth > 0"
        class="affordability-preview__segment affordability-preview__segment--green"
        :style="{ width: greenWidth + '%' }">
        {{ greenLabel }}
      </div>
      <div
        v-if="orangeWidth > 0"
        class="affordability-preview__segment affordability-preview__segment--orange"
        :style="{ width: orangeWidth + '%' }">
        {{ orangeLabel }}
      </div>
      <div
        v-if="redWidth > 0"
        class="affordability-preview__segment affordability-preview__segment--red"
        :style="{ width: redWidth + '%' }">
        {{ redLabel }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AffordabilityPreviewBar',
  props: {
    maxAffordabilityPercent: {
      type: [Number, String],
      default: 0
    },
    tolerancePercent: {
      type: [Number, String],
      default: 0
    }
  },
  computed: {
    maxValue() {
      const parsed = Number(this.maxAffordabilityPercent)
      return Number.isFinite(parsed) ? parsed : 0
    },
    toleranceValue() {
      const parsed = Number(this.tolerancePercent)
      return Number.isFinite(parsed) ? parsed : 0
    },
    greenWidth() {
      return this.clamp(this.maxValue)
    },
    orangeWidth() {
      return this.clamp(this.toleranceValue - this.greenWidth, 100 - this.greenWidth)
    },
    orangeEnd() {
      return this.clamp(this.toleranceValue)
    },
    redWidth() {
      return Math.max(0, 100 - this.greenWidth - this.orangeWidth)
    },
    greenLabel() {
      return `≤${this.greenWidth}%`
    },
    orangeLabel() {
      return `${this.greenWidth + 1}–${this.orangeEnd}%`
    },
    redLabel() {
      return `${this.orangeEnd + 1}–100%`
    }
  },
  methods: {
    clamp(value, max = 100) {
      if (!Number.isFinite(value) || value <= 0) {
        return 0
      }
      return Math.min(value, max)
    }
  }
}
</script>

<style lang="scss" scoped>
.affordability-preview {
  min-width: 220px;
}

.affordability-preview__bar {
  display: flex;
  overflow: hidden;
  border-radius: 4px;
  min-height: 32px;
  width: 100%;
}

.affordability-preview__segment {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  padding: 0 4px;
}

.affordability-preview__segment--green {
  background-color: #32c766;
}

.affordability-preview__segment--orange {
  background-color: #f6a72a;
}

.affordability-preview__segment--red {
  background-color: #f04e4c;
}
</style>
